import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FORBIDDEN_ROUTE } from '../tokens/forbidden-route.token';
import { NOT_FOUND_ROUTE } from '../tokens/not-found-route.token';

@Injectable({
    providedIn: 'root',
})
export class ErrorHandlerService {
    private readonly forbiddenRoute = inject(FORBIDDEN_ROUTE);
    private readonly notFoundRoute = inject(NOT_FOUND_ROUTE);
    private readonly router = inject(Router);

    public handleError(error: HttpErrorResponse) {
        switch (error.status) {
            case HttpStatusCode.UnprocessableEntity: {
                // Validation error, to be handled in components
                break;
            }
            case HttpStatusCode.Unauthorized: {
                this.router.navigate(['/error'], {
                    queryParams: { code: 'unauthorized' },
                });
                break;
            }
            case HttpStatusCode.Forbidden: {
                this.router.navigate([this.forbiddenRoute()], {
                    skipLocationChange: true,
                });
                break;
            }
            case HttpStatusCode.NotFound: {
                this.router.navigate([this.notFoundRoute], {
                    skipLocationChange: true,
                });
                break;
            }
            default: {
                // TODO #REM578: Display notification..?
                /*
                const logMessage = `User: ${this.currentUserService.getCurrentUser()
                    ?.name}
    Name: ${error.name}
    HttpStatus: ${error.status}
    Url: ${error.url}
    Message: ${error.message}
    `;

                console.warn(logMessage);
                */
            }
        }
    }
}
